export default __webpack_public_path__ + "static/media/wall-mounted.c34bcc23.svg";